/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_SuspendedInputs */



/**
* | output |
* | --- |
* | "Your access to this workspace is paused. Ask your admin to restore it." |
*
* @param {Signin_Sso_X15_SuspendedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_suspended = /** @type {((inputs?: Signin_Sso_X15_SuspendedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_SuspendedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Your access to this workspace is paused. Ask your admin to restore it.")
});